module.exports = __webpack_public_path__ + "img/tarj2-1.9c3613b7.png";